/* eslint-disable import/prefer-default-export */
import * as yup from "yup";

export const firstName = yup.string().trim().label("First Name").required();
export const lastName = yup.string().trim().label("Last Name").required();
export const email = yup
  .string()
  .trim()
  .label("Email Address")
  .required()
  .email();

export const password = yup.string().required().min(10).label("Password");
